module.exports = __webpack_public_path__ + "static/img/15.8537fc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/companyLogo/15.png
// module id = pYwr
// module chunks = 1